import { render } from "./site-inspectors.vue?vue&type=template&id=8dd183a0"
import script from "./site-inspectors.vue?vue&type=script&lang=js"
export * from "./site-inspectors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__